<form [formGroup]="terugBetaaldePrestatiebeursAangeverFg">
    <div *ngIf="terugBetaaldePrestatiebeursAangever.length > 0">
        <div formArrayName="terugBetaaldePrestatiebeursAangever">
            <div *ngFor="let item of terugBetaaldePrestatiebeursAangever.controls; let i = index; "
                    [formGroupName]="i" class="row" >
                    <snelstart-ui-select-form-control formControlName="onderwijsJaar"
                                                      [label]="i === 0 ? 'Studiejaar' : ''"
                                                      [options]="this.incomeTaxEntity.year! < 2025 ? onderwijsJaar : onderwijsJaar2025"
                                                      [required]=true
                                                      class="col-auto custom-input-250"
                                                        (change)="initializeStudiemaandAanvang(i)"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-select-form-control [label]="i === 0 ? 'Mbo' : ''"
                                                      formControlName="mbo"
                                                      id="mbo-{{i}}"
                                                      [options]="optionsJaNee"
                                                      [required]=true
                                                      class="col-auto custom-input-100"
                                                      [disabledControl]="isMboDisabled(i)"
                                                      (change)="saveForm()"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-select-form-control [label]="i === 0 ? 'Hbo/Wo' : ''"
                                                      formControlName="hboWo"
                                                      id="mbo-{{i}}"
                                                      [options]="optionsJaNee"
                                                      [disabledControl]="isHboDisabled(i)"
                                                      class="col-auto custom-input-100"
                                                      (change)="saveForm()"
                    >
                    </snelstart-ui-select-form-control>
                    <div formGroupName="periodeWaaroverTerugbetaaldMoetWordenInMaanden" class="row col-auto">
                        <snelstart-ui-select-form-control
                                [label]="i === 0 ? 'Van' : ''"
                                formControlName="begindatum"
                                id="hboWo-{{i}}"
                                [options]="this.incomeTaxEntity.year != 2025 ? studiemaandAanvang : studiemaandAanvang2025"
                                class="col-auto custom-input-200"
                                [disabledControl]="isHboAndMboDisabled(i)"
                                (change)="saveForm()"
                        >
                        </snelstart-ui-select-form-control>
                        <snelstart-ui-select-form-control
                                [label]="i === 0 ? 'Tot en met' : ''"
                                formControlName="einddatum"
                                id="hboWo-{{i}}"
                                [options]="this.incomeTaxEntity.year != 2025 ? studiemaandEind : studiemaandEind2025"
                                class="col-auto custom-input-200"
                                [disabledControl]="isHboAndMboDisabled(i)"
                                (change)="saveForm()"
                        >
                        </snelstart-ui-select-form-control>

                    </div>
                    <snelstart-ui-number-form-control formControlName="terugbetaaldeBedrag"
                                                      id="terugbetaaldeBedrag"
                                                      [label]="i === 0 ? 'Terugbetaald bedrag' : ''"
                                                      class="col-auto custom-input-200"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      [disabledControl]="isHboAndMboDisabled(i)"
                                                      (change)="saveForm()"
                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button id="buttonDeleteKosten"
                                                type="secondary"
                                                size="medium"
                                         icon="trash"
                                                iconType="light"
                                                (click)="verwijderRijTerugBetaaldePrestatiebeursAangever(i)"
                                                [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                    >
                    </snelstart-ui-button>
                </div>
        </div>
    </div>

</form>

<div *ngIf="terugBetaaldePrestatiebeursAangever.length === 0">
    <snelstart-ui-button class="snelstart-ui-button" type="link" icon="plus"
                         (click)="addRijTerugBetaaldePrestatiebeursAangever()">Terugbetaalde prestatiebeurs
    </snelstart-ui-button>
</div>
<!--<div *ngIf="terugBetaaldePrestatiebeursAangever.length > 0">-->
<!--    <snelstart-ui-button class="snelstart-ui-button" type="link" icon="plus"-->
<!--                         (click)="addRijTerugBetaaldePrestatiebeursAangever()">Terugbetaalde prestatiebeurs toevoegen-->
<!--    </snelstart-ui-button>-->
<!--</div>-->
